require('normalize.css/normalize.css');
require('styles/bootstrap/css/bootstrap.min.css');
require('styles/bootstrap/css/bootstrap-theme.min.css');
require('styles/App.css');

import React from 'react';
import HeaderComponent from './HeaderComponent.js'
import HomeComponent from './HomeComponent.js'
import QuemSomosPageComponent from './QuemSomosPageComponent.js'
import SoftwarePageComponent from './SoftwarePageComponent.js'
import DownloadsPageComponent from './DownloadsPageComponent.js'
import ClientsPageComponent from './ClientsPageComponent.js'
import GestaoPageComponent from './GestaoPageComponent.js'
import PrivacyPolicyPageComponent from './PrivacyPolicyPageComponent'
import Banner from './Banner.js'
import FooterComponent from './FooterComponent.js'
import FloatingButtonsComponent from './FloatingButtonsComponent.js'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import { Router, Route } from 'react-router'
import Cookies from 'js-cookie'
import 'whatwg-fetch'

import createBrowserHistory from 'history/createBrowserHistory'

const history = createBrowserHistory()

let prevLocation = {};
history.listen(location => {
  const pathChanged = prevLocation.pathname !== location.pathname;
  const hashChanged = prevLocation.hash !== location.hash;
  if (pathChanged || hashChanged) window.scrollTo(0, 0);
  prevLocation = location;
});

class AppComponent extends React.Component {
  constructor(props) {
    super(props)
    this.dismissCookieWarning = this.dismissCookieWarning.bind(this);
    let cookieBool = Cookies.get('alertWasRead') ? true : false;
    this.state = {
      alertWasRead: cookieBool
    }
  }

  dismissCookieWarning() {
    Cookies.set('alertWasRead', true, { expires: 30 })
    this.setState({
      alertWasRead: true
    })
  }

  render() {
    return (
      <div className="site-container">
        <Router history={history}>
          <div>
            <HeaderComponent />
            <ReactCSSTransitionGroup
              transitionName="fade"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}>
              <Route exact path="/" key={'index'} component={HomeComponent} />
              <Route path="/quem-somos" key={'quem-somos'}  component={QuemSomosPageComponent} />
              <Route path="/solucoesamedida" key={'solucoesamedida'}  component={SoftwarePageComponent} />
              <Route path="/downloads" key={'downloads'}  component={DownloadsPageComponent} />
              <Route path="/gestao" key={'gestao'}  component={GestaoPageComponent} />
              <Route path="/politica-de-privacidade" key={'politicaprivacidade'}  component={PrivacyPolicyPageComponent} />
            </ReactCSSTransitionGroup>
            <FooterComponent />
          </div>
        </Router>
        <FloatingButtonsComponent />
        {!this.state.alertWasRead &&
          <div className={'cookie-info'} onClick={this.dismissCookieWarning}>
            <p>Este site utiliza cookies para melhorar a sua experiência.</p>
            <button onClick={this.dismissCookieWarning}>Compreendi</button>
          </div>
        }

      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js